let BranchFactory = function ($rootScope, SetupService, Auth, $q, Modal) {
    let getBranchDetails = (branchId) => {
        const defer = $q.defer();
        SetupService.get(branchId)
          .then((setup) => {
            return defer.resolve(setup);
          })
          .catch((err) => {
            if (err && err.data && err.data.message) {
              Modal.errorModal('error.' + err.data.message);
            }
            return defer.resolve(err);
          });
        return defer.promise;
    }

    return {
        getBranchDetails
    }
}

BranchFactory.$inject = ['$rootScope', 'SetupService', 'Auth', '$q', 'Modal'];

export default BranchFactory;


// WEBPACK FOOTER //
// ./client/app/common/branch/branch.factory.js